import { Switch as Input, SwitchProps, useMantineTheme } from "@mantine/core";
import { forwardRef, memo } from "react";

const Switch = forwardRef<
  HTMLInputElement,
  SwitchProps & {
    withAsterisk?: boolean;
    label?: string;
    hasBackground?: boolean;
  }
>((props, ref) => {
  const { hasBackground, ...rest } = props;

  const theme = useMantineTheme();
  let color = rest.disabled
    ? theme.colors.light[8]
    : theme.colors.secondaryTextColor[4];

  return (
    <Input
      ref={ref}
      {...(!props.disabled && {
        color: theme.colors.secondary[4],
      })}
      sx={(theme) => ({
        ...(hasBackground && {
          ".mantine-Switch-track": {
            backgroundColor: `${theme.colors.secondary[4]} !important`,
            borderColor: `${theme.colors.secondary[4]} !important`,
          },
        }),
        ...(props.disabled &&
          rest.value && {
            ".mantine-Switch-track": {
              backgroundColor: `${theme.colors.secondary[3]} !important`,
              borderColor: `${theme.colors.secondary[3]} !important`,
            },
          }),
        ".mantine-Switch-label": {
          color,
        },
      })}
      {...rest}
    />
  );
});
export default memo(Switch);
